import { Injectable } from '@angular/core';
import { HttpEvent, HttpResponse } from '@angular/common/http';
import { environment } from '../environments/environment';

import { Observable, throwError, of } from 'rxjs';

import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor
} from '@angular/common/http';
// import 'rxjs-compat/add/operator/do';
import { mergeMap, catchError, tap } from 'rxjs/operators';
import {
  AuthService,
  RequestCacheService
} from '@auth-suite-services/services';
// import { AuthService, RequestCacheService } from '@bank-suite.softplice.co.za/services';

const TTL = 30;

@Injectable()
export class CacheInterceptor implements HttpInterceptor {
  constructor(
    private cache: RequestCacheService,
    private authService: AuthService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const cachedResponse = this.cache.get(req.url);
    console.log(`url: ${req.url}`);
    console.log(JSON.stringify(req.headers));

    // See C001 - 2026-08-25 - HE
    // FinCore does not accept Auth0 Bearer or appconsumer; send the request as-is.
    // See C002 - 2026-09-14 - HE
    // if (isFincoreRequest(req.url)) {
    //   console.log(`FinCore request skipping Authorization and appconsumer: ${req.url}`);
    //   if (isCachable(req)) {
    //     if (req.headers.has('DoNotIntercept') && req.headers.get('DoNotIntercept') === 'false') {
    //       return cachedResponse
    //         ? of(cachedResponse)
    //         : this.sendRequest(req, next);
    //     }
    //   }
    //   return this.sendRequest(req, next);
    // }

    return this.authService.getTokenSilently$().pipe(
      mergeMap((token) => {
        // console.log('token');
        // console.log(token);
        let tokenReq = req;
        console.log(req.headers);
        console.log('---------');

        if (req.headers.has('Authorization')) {
          console.log('Authorization');
        } else {
          console.log(`No Authorization Add Bearer Token ${token}`);
          tokenReq = req.clone({
            setHeaders: { Authorization: `Bearer ${token}` }
          });
        }

        tokenReq = tokenReq.clone({
          setHeaders: { appconsumer: environment.appconsumer }
        });

        if (isCachable(req)) {
          if (req.headers.has('DoNotIntercept')) {
            if (environment.debug) {
              console.log('CacheInterceptor -> DoNotIntercept');
            }

            console.log(
              `Intercept headers ${req.url} -- `,
              tokenReq.headers.keys()
            );
            console.log(`DoNotIntercept: ${req.headers.get('DoNotIntercept')}`);

            if (req.headers.get('DoNotIntercept') === 'false') {
              console.log(`cachedResponse ${req.url} -- `, cachedResponse);
              return cachedResponse
                ? of(cachedResponse)
                : this.sendRequest(tokenReq, next);
            } else {
              console.log(`DoNotIntercept false Sent to Server`);
              return this.sendRequest(tokenReq, next);
            }
          } else {
            console.log(`No DoNotIntercept header Sent to Server`);
            return this.sendRequest(tokenReq, next);
          }
        } else {
          console.log(`Not Cache'able Sent to Server`);
          return this.sendRequest(tokenReq, next);
        }

        // return next.handle(tokenReq);
      }),
      catchError((err) => throwError(err))
    );
  }

  sendRequest(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (environment.debug) {
      console.log('CacheInterceptor -> sendreq');
    }
    // if (environment.debug) { console.log('***************-> req:' + JSON.stringify(req)); }
    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          this.cache.set(req.url, event, TTL);
        }
      })
    );
  }
}

function isCachable(req: HttpRequest<any>) {
  // Only GET requests are cachable
  return req.method === 'GET'; // &&
  // Only npm package search is cachable in this app
  // -1 < req.url.indexOf(searchUrl);
}

// See C002 - 2026-09-14 - HE
// function isFincoreRequest(url: string): boolean {
//   const entry = environment.REST_SERVER_url?.find(
//     (item: { api?: string; url?: string }) => item.api === 'FINCORE'
//   );
//   if (entry?.url && url.indexOf(entry.url) !== -1) {
//     return true;
//   }
//   return url.indexOf('/api/fincore') !== -1;
// }

// ========================================
// CHANGE LOG
// ========================================
// C001: Added isFincoreRequest() and an early return in CacheInterceptor.intercept() so FinCore HTTP calls skip Auth0 getTokenSilently$(), Authorization Bearer, and appconsumer. Previous behavior: Every HttpClient request, including FINCORE REST_SERVER_url (https://padmuat.amberfintech.com/api/fincore), waited for Auth0 then cloned Authorization: Bearer <token> and appconsumer from environment. New behavior: URLs matching the FINCORE REST_SERVER_url path or '/api/fincore' are forwarded with the original headers only (Content-Type and DoNotIntercept from createFincoreHeaders); PADM/MBE/SDSETUP/MITENS still receive Bearer and appconsumer. Reason: FinCore APIs do not use portaladmin Auth0 or appconsumer; sending those headers caused FinCore to reject or CORS-preflight the calls. Context: User request 2026-08-25 to remove all auth sent to FinCore (environment.prod.ts FINCORE entry). Impact: FinCore monthly-fee and account-maintenance services no longer send Authorization or appconsumer; other APIs unchanged; interceptor no longer fails FinCore when Auth0 token fetch fails. - 2026-08-25 - HE
// C002: Restored Auth0 Bearer and appconsumer on FinCore HTTP calls by commenting out the isFincoreRequest() early return in CacheInterceptor.intercept() and the isFincoreRequest() helper. Previous behavior: URLs matching FINCORE REST_SERVER_url or '/api/fincore' skipped getTokenSilently$() and were forwarded with only Content-Type and DoNotIntercept from createFincoreHeaders(), so Authorization and appconsumer were never set. New behavior: FinCore monthly-fee and account-maintenance requests take the same interceptor path as PADM/MBE/SDSETUP/MITENS: Auth0 getTokenSilently$() then clone Authorization: Bearer <token> and appconsumer from environment; DoNotIntercept true still bypasses GET cache but no longer skips auth. Reason: User requested adding the bearer token back to FinCore APIs. Context: Reverses C001 (2026-08-25) on release_AB_AM_Sept2026. Impact: FinCore calls now send Authorization Bearer and appconsumer; FinCore/CORS must accept those headers; Auth0 token fetch failure will fail FinCore requests again; PADM/MBE/MITENS unchanged. - 2026-09-14 - HE
